import { useGalleryAnchor } from './useGalleryAnchor';
import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { LiveStepList } from '@/components/ui';
import { TypedProperties } from '@/components/objects/TypedField';
import { formStates } from '@/components/object-forms/formData';
import { FORM_DEFINITIONS, FORM_HOME, initialFormValues } from '../object-forms/model';
import { Section, Code } from '@/pages/design/sections/Section';
export function ObjectFormsSection() {
  useGalleryAnchor('object-form-patterns');
  const { hash } = useLocation();
  useEffect(() => {
    if (hash !== '#object-form-patterns') return;
    let active = true;
    const align = () => {
      if (active)
        document
          .getElementById('object-form-patterns')
          ?.scrollIntoView({ block: 'start', behavior: 'instant' });
    };
    const frame = requestAnimationFrame(align);
    void document.fonts.ready.then(align);
    return () => {
      active = false;
      cancelAnimationFrame(frame);
    };
  }, [hash]);
  return (
    <Section
      id="object-form-patterns"
      title="Форма и пошаговое создание"
      lead="Одни поля для правки целого объекта и мастера. Проверка по месту, черновик, возврат и отмена."
    >
      <div className="grid min-w-0 items-start gap-6 lg:grid-cols-2">
        <div className="min-w-0 rounded-lg border border-line bg-card p-5">
          <h3 className="mb-1 type-heading">Форма по разделам</h3>
          <p className="mb-4 text-xs text-fg-muted">
            Изменения собираются вместе и сохраняются одним действием.
          </p>
          <TypedProperties
            definitions={FORM_DEFINITIONS.filter((d) => ['title', 'category', 'owner'].includes(d.id))}
            values={formStates(initialFormValues('edit'))}
            editable={false}
          />
          <p className="mt-4">
            <Code>ObjectForm · ObjectFormSection[]</Code>
          </p>
          <Link
            to={FORM_HOME}
            className="mt-4 inline-flex items-center gap-2 rounded-sm text-xs font-medium text-brand-fg hover:underline focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
          >
            Заполнить форму
            <ArrowRight className="size-4" />
          </Link>
        </div>
        <div className="min-w-0 rounded-lg border border-line bg-card p-5">
          <h3 className="mb-1 type-heading">Мастер с возвратом</h3>
          <p className="mb-4 text-xs text-fg-muted">
            Раздел проверяется перед переходом. Введённое остаётся на месте.
          </p>
          <LiveStepList
            variant="compact"
            steps={[
              {
                id: 'basics',
                label: 'Основа',
                status: 'done',
                details: <p className="text-xs text-fg-muted">Название и категория заполнены.</p>,
              },
              {
                id: 'people',
                label: 'Ответственность',
                status: 'active',
                details: <p className="text-xs text-fg-muted">Выбор ответственного и способа связи.</p>,
              },
              {
                id: 'terms',
                label: 'Условия',
                status: 'pending',
                details: <p className="text-xs text-fg-muted">Период, бюджет и теги.</p>,
              },
              {
                id: 'review',
                label: 'Проверка и создание',
                status: 'pending',
                details: <p className="text-xs text-fg-muted">Обзор всех значений перед подтверждением.</p>,
              },
            ]}
          />
          <p className="mt-4">
            <Code>ObjectWizard · LiveStepList</Code>
          </p>
          <Link
            to={FORM_HOME + '?view=wizard'}
            className="mt-4 inline-flex items-center gap-2 rounded-sm text-xs font-medium text-brand-fg hover:underline focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
          >
            Пройти мастер
            <ArrowRight className="size-4" />
          </Link>
        </div>
      </div>
    </Section>
  );
}
